type ExamplePartnerCandidate = {
	user?: {
		id: string;
		first_name: string;
		display_name: string;
	};
};

/** Pick someone plausible for an example prompt — first leaderboard row that isn't the viewer. */
export function pickExamplePartnerFirstName(records: ExamplePartnerCandidate[], currentUserId: string): string | undefined {
	const partner = records.find((record) => record.user?.id && record.user.id !== currentUserId)?.user;
	if (!partner) return undefined;

	return partner.first_name || partner.display_name.split(/\s+/)[0];
}

export function partnerDisplayFirstName(user?: { displayFirstName?: string; firstName?: string }): string | undefined {
	return user?.displayFirstName ?? user?.firstName;
}

export function partnerNameFromPageName(pageName: string | undefined): string | undefined {
	if (!pageName?.startsWith('1:1 with ')) return undefined;

	const name = pageName.slice('1:1 with '.length).trim();
	return name || undefined;
}
